<div>
  <!-- list controls -->
  <div *ngIf="!simplified">

    <div class="column-grid tw-place-items-center tw-gap-2 tw-justify-end tw-mb-4">
      <button mat-button *ngIf="activityTypesFormControl.value?.length" (click)="clearFilter()">Clear</button>
      <mat-form-field class="no-subscript">
        <mat-label>Activity Types</mat-label>
        <mat-select multiple
                    [formControl]="activityTypesFormControl"
                    (selectionChange)="filter()">
          <mat-option *ngFor="let option of (activityTypes$ | async)"
                      [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </div>

  <!-- list -->
  <div class="activity-stream-content tab-pane-content">
    <div class="activity-stream-list">
      <p *ngIf="error">No activities loaded. Please try again later.</p>
      <borrower-activity *ngFor="let activity of (activities$ | async)" [borrower]="borrower" [activity]="activity" [simplified]="simplified"></borrower-activity>
    </div>
  </div>

  <!-- load more -->
  <div class="tw-py-6 tw-grid tw-grid-flow-col tw-justify-center">
    <button *ngIf="!(activitiesLoading$ | async) else loading" (click)="loadMore()" class="btn btn-primary btn-action">Load More</button>

    <ng-template #loading>
      <mat-spinner diameter="38"></mat-spinner>
    </ng-template>
  </div>

</div>
